import axios from "axios";
import * as actionType from "../actionTypes";
import apiConstants from "../../constans/apiConstants";
import { toaster } from "../../utils/utils";


export const submitRoleAction = (no, role, cb) => async(dispatch) => {
    try {
       const res = await axios.put(`${apiConstants().AUTH_API_URL}api/v1/auth/editUserRole/${no}?role=${role}
       `,{},  {
        headers: {
        authorization: localStorage.getItem("token"),
        },
    })
    toaster("success", res.data.message)
    if (cb) {
        cb()
    }
    } catch (err) {
        console.log(`err`, err)
    }
}
